import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  textAreaInnerWrapper: FelaCSS;
}

const styles: IStyles = {
  textAreaInnerWrapper: {
    minHeight: 'auto',
  },
};

export default styles;
